import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { disposeTheNodeHaveNoChild } from '../../utils/toolsForCommon'
import { ElMessageComponent } from 'element-ui/types/message'
import Vue from 'vue'
let vm: any = new Vue()

@Module({ name: 'Canteen', namespaced: true, stateFactory: true })
export default class Canteen extends VuexModule {
  public treeDataForSubject: any[] = []
  public treeDataForDisposeNameSubject: any[] = []

  // 设置科目--普通的：
  @Mutation
  public setTreeDataForSubject (treeDataForSubject: any) {
    this.treeDataForSubject = treeDataForSubject
  }

  // 设置科目--处理了name字段的：
  @Mutation
  public setTreeDataForDisposeNameSubject (treeDataForDisposeNameSubject: any) {
    this.treeDataForDisposeNameSubject = treeDataForDisposeNameSubject
  }

  // 获取科目--普通的：
  @Action
  public getTreeDataForSubject () {
    return new Promise(async resolve => {
      try {
        const { data: result } = await vm.$http.subjectTreeOfGet()
        if (result.code !== 200) return vm.$message.error(result.msg)
        const treeDataForSubject = disposeTheNodeHaveNoChild([result.data], 'children')
        this.setTreeDataForSubject(treeDataForSubject)
        resolve(treeDataForSubject)
      } catch (err) {
        console.log(err)
      }
    })
  }

  // 获取科目--处理了name字段的：
  @Action
  public getTreeDataForDisposeNameSubject (): Promise<ElMessageComponent | void> {
    return new Promise(async resolve => {
      try {
        const { data: result } = await vm.$http.subjectTreeOfGet()
        if (result.code !== 200) return vm.$message.error(result.msg)
        // 把树里面的名称和code整合起来：
        const disposeTree = (data) => {
          const dispose = tree => {
            tree.map((item) => {
              if (item.children) {
                dispose(item.children)
              }
              item.orginName = item.name
              item.name = `${item.name}（${item.code}）`
            })
          }
          dispose(data)
          return data
        }
        const treeDataForDisposeNameSubject = disposeTree(disposeTheNodeHaveNoChild(result.data.children, 'children'))
        this.setTreeDataForDisposeNameSubject(treeDataForDisposeNameSubject)
        resolve(treeDataForDisposeNameSubject)
      } catch (err) {
        console.log(err)
      }
    })
  }
}
